<!--
 * @FileDescription: 支付弹窗
 * @Author: 陈文景
 * @Date: 2023-01-06 16:41:06
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :title="$t('PaymentDialog.PayNow')" :visible.sync="visible" width="620px" :before-close="close">
    <div class="amount">
      <p>{{ totalAmount() }}</p>
      <span>{{ $t('PaymentDialog.PaymentAmount') }}</span>
    </div>

    <div>
      <p class="tips">{{ $t('PaymentDialog.PleaseSelectYourPaymentMethod') }}</p>

      <div class="method">
        <div class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :label="2">
            <span class="value">{{ $t('PaymentDialog.Paypal') }}</span>
            <img src="@/assets/img/icon/paypal.png" alt="paypal.png" />
          </el-radio>
        </div>
        <!-- <div v-if="$store.state.common.userGroup === 100" class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :label="1">
            <span class="value">{{ $t('PaymentDialog.CreditCard') }}</span>
            <img src="@/assets/img/icon/creditcard1.png" alt="creditcard.png" />
          </el-radio>
        </div>
        <div v-else class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :label="9">
            <span class="value">{{ $t('PaymentDialog.CreditCard') }}</span>
            <img src="@/assets/img/icon/creditcard1.png" alt="creditcard.png" />
          </el-radio>
        </div> -->
        <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
        <div class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :label="1">
            <span class="value">{{ $t('PaymentDialog.CreditCard') }}</span>
            <img src="@/assets/img/icon/creditcard1.png" alt="creditcard.png" />
          </el-radio>
        </div>
        <div class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :disabled="isDisabled" :label="0">
            <span class="value">{{ $t('PaymentDialog.Balance') }}</span>
            <span class="balance">{{ balance() }}</span>
          </el-radio>
        </div>
        <div class="radio">
          <el-radio v-model="transactionParameter.paymentMethod" :label="3">
            <span class="value">{{ $t('PaymentDialog.Others') }}</span>
            <img src="@/assets/img/icon/zfb_wx.png" alt="zfb_wx.png" />
          </el-radio>
        </div>
      </div>

      <div class="pay-now">
        <el-button type="primary" :loading="loading" @click="onPayment">{{ $t('PaymentDialog.ButtonPayNow') }}</el-button>
      </div>
    </div>

    <!-- Paypal 支付对话框 -->
    <Paypal ref="paypal" @success="paySuccess" @fail="payFailed" />

    <!-- 空中云汇 支付对话框 -->
    <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFailed" />
    <Payoneer ref="payoneer" :payCallbackUrl="payoneerCallbackUrl" />
  </el-dialog>
</template>

<script>
import API from '@/api'
import Paypal from '@/components/Paypal.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'

let transactionParameter = {
  amount: undefined, // 需要支付的总金额
  currencyCode: 'USD', // 币种(默认USD)
  paymentMethod: 2, // 支付方式 0.Balance 1.Credit Card 2.Paypal 3.空中云汇 4.活动审批充值 5.礼品 6.使用信用额度(Credit) 7.信用授信(Authorized)
  paymentType: 7, // 支付类型: -1.退款 0.购买 1.一件代发 2.样品 3.充值 4.订货（尾款）5.订货（押金）7.账单付款 ---> 此处默认传7
  kkOrderIds: [] // 此字段取数据中的billId字段的值(账单IDs)
}

export default {
  components: {
    Paypal,
    Airwallex,
    Payoneer
  },
  data() {
    return {
      visible: false,

      radio: 2, // 当前选中的单选框（绑定的值为支付方式）

      // 当前用户余额信息
      balanceInfo: {
        balance: undefined, // 用户余额
        currencyCode: undefined // 货币代码
      },

      transactionParameter: { ...transactionParameter }, // 创建交易单的请求参数
      paymentFlowNumber: undefined, // 支付流水单号

      loading: false // 支付按钮的加载状态
    }
  },
  computed: {
    payCallbackUrl() {
      return `${location.origin}/payment-status?state=success&orderId=${this.transactionParameter.kkOrderIds && this.transactionParameter.kkOrderIds[0]}&paymentMethod=${this.paymentMethod}&paymentAmount=${this.transactionParameter.amount}`
    },
    payoneerCallbackUrl() {
      return `${location.origin}/payment-status?orderId=${this.transactionParameter.kkOrderIds && this.transactionParameter.kkOrderIds[0]}`
    },
    paymentMethod() {
      return this.transactionParameter.paymentMethod === 1 ? 3 : this.transactionParameter.paymentMethod
    },
    totalAmount() {
      return () => {
        return this.transactionParameter.amount ? `US $${this.transactionParameter.amount}` : undefined
      }
    },
    balance() {
      return () => {
        return this.balanceInfo.balance ? `${this.balanceInfo.currencyCode ? this.balanceInfo.currencyCode : 'USD'} $${this.balanceInfo.balance}` : 'USD 0'
      }
    },
    isDisabled() {
      return this.balanceInfo.balance ? this.transactionParameter.amount > this.balanceInfo.balance : true
    }
  },
  methods: {
    /**
     * API 获取当前用户账户余额
     */
    async getBalance() {
      let { data } = await API.getBalance()
      if (data) {
        this.balanceInfo = {
          balance: data.balance, // 用户余额
          currencyCode: data.currencyCode // 货币代码
        }
      }
    },

    /**
     * API 创建交易单
     */
    async getCreateTransactionOrder() {
      try {
        this.loading = true
        let transactionParameter = { ...this.transactionParameter }
        // 需注意：如果为1的时候需转为3
        // 原因为：这两个选项在创建交易单的时候都属于空中云汇
        if (transactionParameter.paymentMethod === 1) {
          transactionParameter.paymentMethod = 3
        }
        let { data } = await API.getCreateTransactionOrder(transactionParameter)
        this.paymentFlowNumber = data // 获取支付流水单号
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 发起余额支付
     */
    async startBalancePayment() {
      try {
        this.loading = true
        let { message } = await API.startBalancePayment(this.paymentFlowNumber)
        this.paySuccess(message)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 支付按钮
     */
    async onPayment() {
      // 1.创建交易单
      await this.getCreateTransactionOrder()
      // 2.根据付款类型选择不同支付组件
      // 2.1 Balance --> 余额支付
      if (this.transactionParameter.paymentMethod === 0) {
        this.startBalancePayment()
      }
      // 2.2 Paypal
      if (this.transactionParameter.paymentMethod === 2) {
        this.$refs.paypal.show(this.paymentFlowNumber)
      }
      // 2.3 空中云汇
      // 2.3.1 Credit Card
      if (this.transactionParameter.paymentMethod === 1) {
        this.$refs.airwallex.show(this.paymentFlowNumber, ['card'])
      }
      // 2.3.2 Others
      if (this.transactionParameter.paymentMethod === 3) {
        this.$refs.airwallex.show(this.paymentFlowNumber, ['wechatpay', 'alipaycn'])
      }
      if (this.transactionParameter.paymentMethod === 9) {
        this.$refs.payoneer.show(this.paymentFlowNumber)
      }
    },

    /**
     * 支付成功的回调
     */
    paySuccess(message) {
      this.close()
      this.$emit('update')
      this.$message.success(message || 'pay success')
    },

    /**
     * 支付失败的回调
     */
    payFailed(error) {
      this.$message.error(error.message)
    },

    /**
     * 对话框显示时的回调
     *
     * @param {Object | Array} payload 当前点击的行对象或当前全部选中的行
     * @param {Number} type 1.单个支付 2.批量支付
     */
    show(payload, type) {
      this.visible = true
      // 单个支付
      if (type === 1) {
        this.transactionParameter.amount = payload.amount
        this.transactionParameter.kkOrderIds = [payload.billId]
      }
      // 批量支付
      if (type === 2) {
        let amount = 0
        this.transactionParameter.kkOrderIds = []
        payload.forEach((item) => {
          amount += item.amount
          this.transactionParameter.kkOrderIds.push(item.billId)
        })
        this.transactionParameter.amount = +amount.toFixed(2)
        amount = null
      }
      // 获取当前用户账户余额信息
      this.getBalance()
    },

    /**
     * 对话框关闭时的回调
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.paymentFlowNumber = undefined
      this.transactionParameter = { ...transactionParameter }
    }
  }
}
</script>

<style lang="scss" scoped>
.radio {
  margin-top: 15px;
  img {
    height: 16px;
  }
  .balance {
    color: #10141d;
    font-weight: 500;
    margin-left: 5px;
  }
}

.amount {
  p {
    color: #10141d;
    font-size: 24px;
    font-weight: 500;
  }
  span {
    color: #8b93a3;
    font-size: 18px;
  }
}

.tips {
  color: #000000;
  font-size: 18px;
  font-weight: 500;
  margin-top: 25px;
}

.pay-now {
  text-align: center;
  margin-top: 50px;
  .el-button {
    width: 300px;
  }
}
</style>
